import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import { Lock, AlertCircle, KeyRound } from 'lucide-react';

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate('/admin/dashboard');
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10 fade-in">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-xl p-8 shadow-sm">
        <div className="flex justify-center mb-6">
          <Logo size="sm" />
        </div>
        <div className="flex items-center gap-2 mb-6">
          <Lock className="text-[#d62828]" size={20} />
          <h1 className="text-2xl font-black brand-text text-neutral-900">Area Admin</h1>
        </div>
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-800 text-sm flex items-center gap-2">
            <AlertCircle size={16} /> {error}
          </div>
        )}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-bold text-neutral-700 mb-1">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" className="w-full px-4 py-2.5 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-[#d62828]/30 focus:border-[#d62828]" />
          </div>
          <div>
            <label className="block text-sm font-bold text-neutral-700 mb-1">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="w-full px-4 py-2.5 border border-neutral-300 rounded focus:outline-none focus:ring-2 focus:ring-[#d62828]/30 focus:border-[#d62828]" />
          </div>
          <button type="submit" disabled={loading} className="w-full px-5 py-3 bg-[#d62828] text-white font-bold rounded hover:bg-[#b41f1f] transition-colors disabled:opacity-60">
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        <p className="text-sm text-neutral-600 text-center mt-6">
          <Link to="/admin/password-dimenticata" className="text-[#d62828] font-bold inline-flex items-center gap-1">
            <KeyRound size={14} /> Password dimenticata?
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
